<template>
  <div class="home">
    <div v-if="infoDomain.entrantsType !=8" class="back-tops">
      <div v-show="isShow" class="right-box">
        <div class="qrcode-box">
          <div class="qrcode">
            <qriously :value="apkUrl" class="img" :size="92" />
          </div>
          <div class="text"><i class="iconfont icon-anzhuo" /> 安卓手机客户端</div>
        </div>
        <div class="triangle" />

      </div>
      <div class=" left-box">
        <div class="iconfont icon-a-lujing7 arrow" @click="toTop" />
        <div class="iconfont icon-erweima qr-code" @mouseenter="isShow = true" @mouseleave="isShow = false" />
      </div>

    </div>
    <div v-for="(item, index) in htmlVal" :key="index">
      <!-- 幻灯片 -->
      <div  v-if="item.id == 81 || item.id == 91 || item.id == 101 || item.id == 111|| item.id == 121 || item.id == 8001"  ref="bannerImg">
          <gfb v-if="item.id == 8001  " />
        <banner-img-eighth v-else   /> 
      

      </div>
      <!-- 金刚区 -->
      <div v-if="item.id == 22 || item.id == 42 || item.id == 52 || item.id == 62" ref="bannerMenu">
        <banner-menu v-if="item.id == 22" />
        <banner-menu-fourth v-else-if="item.id == 42" />
        <banner-menu-fifth v-else-if="item.id == 52" />
      </div>

      <!-- 直播课 -->
      <div v-if="(item.id == 23 || item.id == 33 || item.id == 43 || item.id == 63)  " ref="live">
        <live v-if="item.id == 23 ">{{ item.name }}</live>
        <live-three v-else-if="item.id == 33 ">{{ item.name }}</live-three>
        <live-fourth v-else-if="item.id == 43 ">{{ item.name }}</live-fourth>
      </div>
      <!-- 精品课程 -->
      <div v-if="item.id == 24 ||
        item.id == 34 ||
        item.id == 44 ||
        item.id == 54 ||
        item.id == 74
      " ref="open">
        <open v-if="item.id == 24 ">{{ item.name }}</open>
        <open-three v-else-if="item.id == 34 ">{{ item.name }}</open-three>
        <open-fourth v-else-if="item.id == 44 ">{{ item.name }}</open-fourth>
        <open-fifth v-else-if="item.id == 54 ">{{ item.name }}</open-fifth>

      </div>
      <!-- 热门知识套餐 -->
      <div v-if="item.id == 25 ||
        item.id == 35 ||
        item.id == 45 ||
        item.id == 55 ||
        item.id == 65
      " ref="tuijian">
        <tuijian v-if="item.id == 25 ">{{ item.name }}</tuijian>
        <tuijian-three v-else-if="item.id == 35 ">{{
          item.name
          }}</tuijian-three>
        <tuijian-fourth v-else-if="item.id == 45 ">{{
          item.name
          }}</tuijian-fourth>
        <tuijian-fifth v-else-if="item.id == 55 ">{{
          item.name
          }}</tuijian-fifth>

      </div>
      <!-- VIP专属套餐 -->
      <div v-if="item.id == 47 || item.id == 57 || item.id == 67" ref="vip">
        <vip-fourth v-if="item.id == 47 ">{{ item.name }}</vip-fourth>
        <vip-fifth v-else-if="item.id == 57 ">{{ item.name }}</vip-fifth>
      </div>
      <!-- 师资力量 -->
      <div v-if="item.id == 26 || item.id == 36 || item.id == 66 || item.id == 76
      " ref="teacher">
        <teacher v-if="item.id == 26 ">{{ item.name }}</teacher>
        <teacher-three v-else-if="item.id == 36 ">{{
          item.name
          }}</teacher-three>
      </div>
       <xw v-if="item.id == 8002"></xw>
      <kc v-if="item.id == 8003"></kc>
      <zl v-if="item.id == 8004"></zl>
      <tk v-if="item.id == 8004"></tk>
      <sz v-if="item.id == 8005"></sz>
      <!-- 资讯 -->
      <!-- <div v-if="item.id == 38 " ref="news">
        <news-three>{{ item.name }}</news-three>
      </div> -->
      <!-- <other-functions v-if="item.id == 28" /> -->
    </div>
    <!-- <banner-img-eighth />
    <banner-menu-fifth />
    <live-fourth>直播课</live-fourth>
    <open-fifth>精品课程</open-fifth>
    <tuijian-fifth> </tuijian-fifth>
    <vip-fifth> </vip-fifth> -->
  </div>
</template>

<script>
// import bannerImg from '@/components/homeTwo/bannerImg.vue'  
import bannerImgEighth from '@/components/homeEighth/bannerImg.vue'
import bannerMenuFifth from '@/components/homeFifth/bannerMenu.vue'
import liveFourth from '@/components/homeFourth/live.vue'
import openFifth from '@/components/homeFifth/open.vue'
import tuijianFifth from '@/components/homeFifth/tuijian.vue'
import vipFifth from '@/components/homeFifth/vip.vue'
import bannerMenuFourth from '@/components/homeFourth/bannerMenu.vue' // 菜单
import live from '@/components/homeTwo/live.vue' // 直播课
import liveThree from '@/components/homeThree/live.vue' // 直播课

import bannerMenu from '@/components/homeTwo/bannerMenu.vue' // 菜单
import open from '@/components/homeTwo/open.vue'
import openThree from '@/components/homeThree/open.vue'
import openFourth from '@/components/homeFourth/open.vue'
import tuijian from '@/components/homeTwo/tuijian.vue' // 课程推荐
import tuijianThree from '@/components/homeThree/tuijian.vue' // 课程推荐
import tuijianFourth from '@/components/homeFourth/tuijian.vue' // 课程推荐
import vipFourth from '@/components/homeFourth/vip.vue' // VIP专属套餐
import teacher from '@/components/homeTwo/teacher.vue' // 教师
import teacherThree from '@/components/homeThree/teacher.vue' // 教师
import newsThree from '@/components/homeThree/news.vue' // 资讯
// import otherFunctions from '@/components/homeEighth/otherFunctions.vue'
import gfb from '@/components/gf/bannerImg.vue' // banner图
import xw from '@/components/gf/xw.vue' // banner图
import kc from '@/components/gf/kc.vue' // banner图
import zl from '@/components/gf/zl.vue' // banner图
import tk from '@/components/gf/tk.vue' // banner图
import sz from '@/components/gf/sz.vue' // banner图
import { HomeClient } from "@/api/home";
import { getDomain } from '@/api/cookies'

const homeClient = new HomeClient();
export default {
  name: 'Home',
  components: {
    bannerImgEighth, bannerMenuFifth, liveFourth, openFifth, tuijianFifth, vipFifth, bannerMenu,bannerMenuFourth,live,liveThree,open,openThree,openFourth,tuijian,tuijianThree,tuijianFourth,vipFourth,teacher,teacherThree,newsThree,
    gfb,xw,kc,zl,tk,sz
  },
  data() {
    return {
      apkUrl: '',
      isShow: false,
      infoDomain: {},
      htmlVal: []
    }
  },
  created() {
    this.getAndroidDownloadPackage()
    this.infoDomain = getDomain()
    homeClient.getStore(this.infoDomain.entrantsType).then((res) => {
      if (res.code == 0) {
        this.htmlVal = JSON.parse(res.data.json)
      }
    })
  },
  methods: {

    getAndroidDownloadPackage() {
      homeClient.getAndroidDownloadPackage({ appType: "聚学堂", terminal: 0 }).then((res) => {
        this.apkUrl = res.data.apkUrl;
      });
    },
    goToAbout() {
      this.$router.push('/about')
    },
    toTop() {
      var timer = setInterval(function () {
        const osTop =
          document.documentElement.scrollTop || document.body.scrollTop
        const ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 5)
    },
  }
}
</script>

<style lang="less" scoped>
.clicked {
  /* 添加类名时的样式 */
  display: none;
}

.clicked2 {
  /* 添加类名时的样式 */
  display: none;
}

.clicked3 {
  /* 添加类名时的样式 */
  display: none;
}

.center_guanggao {
  width: 400px;
  height: 466px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -233px;
  margin-left: -200px;
  background-color: #797a9f;
  z-index: 9999999999;
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  border: 1px solid #707070;

  .icon_cuo {
    width: 34px;
    height: 34px;
    opacity: 1;
    position: absolute;
    top: -30px;
    right: -30px;
  }
}

.footer_guanggao {
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -960px;
  width: 1920px;
  height: 70px;
  background-color: #950e8a;
  z-index: 9999999999;

  .icon_cuo {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    margin-top: -15px;
    right: 0;
    margin-right: 172px;
  }
}

.header_guanggao {
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -960px;
  width: 1920px;
  height: 70px;
  background-color: #3177ff;
  z-index: 9999999999;

  .icon_cuo {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    margin-top: -15px;
    right: 0;
    margin-right: 172px;
  }
}

.home {
  width: 100%;
  height: 100%;
  position: relative;
  // padding-top: 68px;
}

//隐藏滚动条
::-webkit-scrollbar {
  display: block !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
}

.back-top {
  width: 218px;
  position: fixed;
  right: -5%;
  top: 20%;
  z-index: 1000;
  display: flex;

  .left-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    .titleimg {
      animation: move5 2s linear infinite alternate both;
      cursor: pointer;
    }

    img {
      opacity: 1;
      margin-bottom: 20px;
    }

    .arrow {
      width: 64px;
      height: 64px;
      background: #ffffff;
      opacity: 1;
      border: 1px solid #eaeaea;
      border-radius: 40px;
      cursor: pointer;
      opacity: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      margin-bottom: 20px;

      .text {
        width: 24px;
        height: 32px;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        top: -15px;
      }

      .text3 {
        width: 36px;
        height: 16px;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        top: -25px;
      }

      .img1 {
        width: 25px;
        height: 25px;
      }

      .img5 {
        width: 22px;
        height: 27px;
      }
    }

    .foodimg {
      width: 64px;
      height: 104px;
      animation: move5 2s linear infinite alternate both;
      cursor: pointer;
    }

    img:hover {
      opacity: 1;
      transition: 100ms;
    }

    .qr-code:hover {
      color: #3177ff;
      transition: 100ms;
    }

    .arrow:hover {
      background: linear-gradient(180deg, #00c19e 0%, #00ab8c 100%);
      border: 1px solid #00c19e;
    }
  }

  .left-boxs {
    width: 52px;
    // height: 96px !important;
    border-radius: 7px;
    // background-color: #ffffff;
    // box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.11);
    opacity: 0.59;

    .arrow {
      font-size: 24px;
      text-align: center;
      height: 48px;
      line-height: 48px;
      cursor: pointer;
      opacity: 1;
    }

    .arrow:hover {
      color: #3177ff;
      transition: 100ms;
    }
  }

  .right-box1 {
    display: flex;
    align-items: center;
    position: relative;
    left: -250px;
    top: -150px;

    .triangle {
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-left-color: #ffffff;
    }

    .qrcode-box {
      width: 130px;
      height: 35px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #00b090;
      text-align: center;
      padding-top: 8px;
    }
  }

  .right-box2 {
    display: flex;
    align-items: center;
    position: relative;
    left: -250px;
    top: -90px;

    .triangle {
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-left-color: #ffffff;
    }

    .qrcode-box {
      width: 126px;
      min-height: 128px;
      border-radius: 8px;
      padding: 6px 5px;
      background-color: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.01);

      img {
        width: 116px;
        height: 128px;
      }

      .title {
        text-align: center;
        color: #444444;
        font-size: 18px;
        font-size: 600;
      }

      .qrcode {
        margin: auto;
        width: 92px;
        height: 92px;
        margin-bottom: 6px;
      }

      .text {
        color: #717171;
        font-size: 10px;
      }
    }
  }

  .right-box3 {
    display: flex;
    align-items: center;
    position: relative;
    left: -250px;
    top: -60px;

    .triangle {
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-left-color: #ffffff;
    }

    .qrcode-box {
      width: 126px;
      min-height: 128px;
      border-radius: 8px;
      padding: 6px 5px;
      background-color: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.01);

      img {
        width: 100%;
        // height: 128px;
      }

      .qrcode {
        margin: auto;
        width: 92px;
        height: 92px;
        margin-bottom: 6px;
      }

      .text {
        color: #717171;
        font-size: 10px;
      }
    }
  }

  .right-box4 {
    display: flex;
    align-items: center;
    position: relative;
    left: -324px;

    .triangle {
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-left-color: #ffffff;
    }

    .qrcode-box {
      width: 126px;
      // min-height: 158px;
      border-radius: 8px;
      padding: 8px 11px;
      background-color: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.01);

      .title {
        text-align: center;
        color: #444444;
        font-size: 18px;
        font-size: 600;
      }

      .qrcode {
        margin: auto;
        width: 92px;
        height: 92px;
        margin-bottom: 6px;
      }

      .text {
        color: #717171;
        font-size: 10px;
      }
    }
  }

  .right-box {
    display: flex;
    align-items: center;
    position: relative;
    left: -250px;
    top: 20px;

    .triangle {
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-left-color: #ffffff;
    }

    .qrcode-box {
      width: 126px;
      // min-height: 128px;
      border-radius: 8px;
      padding: 6px 5px;
      background-color: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.01);

      img {
        width: 100%;
        // height: 128px;
      }

      .qrcode {
        margin: auto;
        width: 92px;
        height: 92px;
        margin-bottom: 6px;
      }

      .text {
        color: #717171;
        font-size: 10px;
      }
    }
  }
}

@keyframes move5 {
  20% {
    transform: rotateY(0deg);
  }

  100% {
    transform: rotateY(180deg);
  }
}

.back-tops {
  // width: 218px;
  position: fixed;
  right: 20px;
  top: 50%;
  z-index: 1000;
  display: flex;

  .left-box {
    width: 52px;
    height: 96px !important;
    border-radius: 7px;
    background-color: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.11);
    opacity: 0.59;

    .arrow {
      font-size: 24px;
      text-align: center;
      height: 48px;
      line-height: 48px;
      cursor: pointer;
      opacity: 1;
    }

    .qr-code {
      font-size: 36px;
      text-align: center;
      height: 48px;
      line-height: 48px;
      cursor: pointer;
      opacity: 1;
    }

    .qr-code:hover {
      color: #3177ff;
      transition: 100ms;
    }

    .arrow:hover {
      color: #3177ff;
      transition: 100ms;
    }
  }

  .left-boxs {
    width: 52px;
    // height: 96px !important;
    border-radius: 7px;
    background-color: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.11);
    opacity: 0.59;

    .arrow {
      font-size: 24px;
      text-align: center;
      height: 48px;
      line-height: 48px;
      cursor: pointer;
      opacity: 1;
    }

    .qr-code {
      font-size: 36px;
      text-align: center;
      height: 48px;
      line-height: 48px;
      cursor: pointer;
      opacity: 1;
    }

    .qr-code:hover {
      color: #3177ff;
      transition: 100ms;
    }

    .arrow:hover {
      color: #3177ff;
      transition: 100ms;
    }
  }

  .right-box {
    display: flex;
    align-items: center;

    .triangle {
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-left-color: #ffffff;
    }

    .qrcode-box {
      width: 126px;
      // min-height: 158px;
      border-radius: 8px;
      padding: 8px 11px;
      background-color: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.01);

      .title {
        text-align: center;
        color: #444444;
        font-size: 18px;
        font-size: 600;
      }

      .qrcode {
        margin: auto;
        width: 92px;
        height: 92px;
        margin-bottom: 6px;
      }

      .text {
        color: #717171;
        font-size: 10px;
      }
    }
  }
}
</style>